import type { FaireProductEntity } from "../../entity_types/product";

export const p_bw9q7fthrt: FaireProductEntity = {
  token: "p_bw9q7fthrt",
  type: "product",
  name: "Mom’s Little Luxuries Gift Box – Ready-to-Gift Mother’s Day",
  brandToken: "b_bexub9fxt6",
  brandName: "Dot & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2e4a16063b5923495ab14755328ae088e1cbc67da62721551b285a98f1415219.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5c46343dbb7e73b4778ca24c7d5925865d146b926784818a1e4d22da80f7bde.jpeg",
    "https://cdn.faire.com/fastly/11fd9f5bca18c1103783161a420c96a1435674e7e53b7213f527c995e8c710f2.jpeg",
    "https://cdn.faire.com/fastly/ba8b3c3a9cecf5cdc5e1030f24967b4538c4bb6aba02c6966737bdcd5d9c6b10.jpeg",
    "https://cdn.faire.com/fastly/78700ee8fbe45b06dbf251f8178c0e0309aeee003e326661699167e70133fbba.jpeg",
    "https://cdn.faire.com/fastly/422092689c2615b8ffcdb6bc2c7e742dbbb9fab9485efc06329797f8aa7ceb67.jpeg",
    "https://cdn.faire.com/fastly/834a67e06cd3d12f37623b3b4b61aca66d7fb8bb16783ea07f25b1cf072aa153.jpeg",
    "https://cdn.faire.com/fastly/288a93b93acf094b35cfdd1a7e95b5bbde3da9160e61a558b10388aa4eac56cb.jpeg",
    "https://cdn.faire.com/fastly/a9efd67a170b2d7f8062d3e80814502787073f752b0cec6c144b7165ba16bd1a.png",
  ],
  priceDollars: 16,
  description:
    "A charming collection of mini self-care favorites, beautifully packaged and ready to gift. The Mom’s Little Luxuries Gift Box is designed for easy Mother’s Day merchandising and grab-and-go gifting.\n\nEach box includes five of our best-selling, handmade self-care essentials in travel-friendly sizes, arranged in a floral gift box that requires no additional wrapping.\n\nPerfect for boutique displays, checkout areas, and impulse purchases.\n\nIncludes\n\n• Mini Butter Babees (9g) – moisturizing lotion beads\n• Mini Sugar Babees (9g) – gentle sugar exfoliating beads\n• Cuticle Oil Pen – nourishing almond & apricot kernel oils\n• Natural Lip Balm – beeswax & apricot kernel oil\n• Relaxing Bath Tea – botanical bath soak\n\nRetail Info\n\nSuggested Retail: $29\nBeautifully packaged and ready to gift.\n\nOrdering Details\n\n• Minimum Order: 4 boxes (1 of each scent)\n• Available in 4 spring scents\n\nRetail Display Tip\n\nOpen one box as a display sample so customers can see the contents and textures.\n\n✨ Wholesale Bonus\n\nOrder 12+ boxes and receive a FREE display set for your store.",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:19.541Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
